import Modal from '@components/TModal'
import React, {useState, useEffect} from 'react'
import {subscribe} from '../../lib/events'
import Capa from './modalWrappers/capa'

const components = {
  capa: Capa,
}

const GlobalModal = () => {
  useEffect(() => {
    subscribe('global-modal', async ({componentName, title = '', props = {}, size = 'lg'}) => {
      if (modalState.isOpen || !components[componentName]) return null
      let modalResolver
      const modalPromise = new Promise(r => (modalResolver = r))
      setModalState({
        size,
        title,
        componentName,
        componentProps: {...props, modalResolver},
        isOpen: true,
      })
      return modalPromise
    })
  }, [])

  const [modalState, setModalState] = useState({})

  const closeRequested = () => {
    setModalState({})
  }

  return modalState.componentName ? (
    <Modal
      scrollType="content"
      size={modalState.size}
      title={modalState.title}
      closeOnOverlayClick={true}
      fadeInOUt={true}
      onRequestClose={closeRequested}
      isVisible={modalState.isOpen}
      footer={<></>}
    >
      {React.createElement(components[modalState.componentName], modalState.componentProps)}
    </Modal>
  ) : (
    <></>
  )
}

export default GlobalModal
